// removed by extract-text-webpack-plugin
module.exports = {"container":"Rg3LvF7","header":"AyPVvkm","header__focused":"_1s_xFHS","link":"_26xJFIo"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Footer/LinkGroup/index.css
// module id = ./template/components/Footer/LinkGroup/index.css
// module chunks = client.sitechrome